// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ManagePricing_wrapper__9fR8_","inner":"ManagePricing_inner__16GVT"};